export const NOTIFICATION_TYPES = [
  'Breakfast', 
  'Lunch', 
  'Dinner', 
  'Snack', 
  'End of Day', 
  'Water intake', 
  'Fitness', 
  'Wellness', 
  'Fasting widget', 
  'Women cycle', 
  'Lab Results', 
  'New content', 
  'New program',
  'Custom'
];

export const ASC_SORT = 'ASC';
export const DESC_SORT = 'DESC';
